<div class="admin-settings-container">
    <h1>Admin Settings</h1>
    <div *ngIf="actionInProgress$ | async" class="settings-spinner">
        <mat-spinner diameter="100"></mat-spinner>
    </div>
    <mat-tab-group>
        <mat-tab *ngFor="let tab of tabs" [label]="tab.label">
            <ng-container *ngIf="tab.component === 'general'">
                <app-general-settings [actionInProgress$]="actionInProgress$"></app-general-settings>
            </ng-container>
            <ng-container *ngIf="tab.component === 'sms'">
                <app-sms-settings [actionInProgress$]="actionInProgress$"></app-sms-settings>
            </ng-container>
            <ng-container *ngIf="tab.component === 'ai'">
                <app-ai-settings [actionInProgress$]="actionInProgress$"></app-ai-settings>
            </ng-container>
        </mat-tab>
    </mat-tab-group>
</div> 